<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Company" tabActive="History" bg="/images/sub/visual/sv-company.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <div class="tit-wrap text-center">
                <h3 class="tit tit--lg">History</h3>
            </div>

            <div class="history-items">
                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2024</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">미정</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>사옥 이전 예정</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2023</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">11.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>자회사 유진 설립</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">07.15</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>
                                        법인사옥 매입 <br />
                                        소재지 : 광진구 능동로 50길 8 (우성빌딩)
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">02.24</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>자회사 유스트레이딩 설립</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">01.30</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>GLOBAL RECYCLED STANDARD(GRS)</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>ORGANIC COTTON STANDARD(OCS)</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>BETTER COTTON INITIATIVE(BCI)</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>친환경 인증 적용</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2022</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">06.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>자회사 연구소로 전환</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>법인 홈페이지 개설</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>신설 법인 설립(소재지 : 서울, 광진구)</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">01.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>법인 관리. 생산을 위한 ERP 시스템 구축</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2021</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-left">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">12.31</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>매출 200% 달성</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">10.28</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>IBK 베스트 파트너(BEST PARTNER)로 지정 - 수출우수기업 인증</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">10.14</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>인력 양성 사업에 관한 HRD 역량 강화 프로그램 <br class="d-none d-md-block" />컨소시엄과 MOU 체결</v-col>
                                </v-row>
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>서울특별시 인재개발원과 상공회의소</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">06.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>계열사 사업부 신설</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2020</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">09.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>법인 건물 매입 [소재지 : 광진구 능동로 344 (동진빌딩)]</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2018</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-left">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">12.05</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>한국무역협회 가입</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">11.22</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>해외 법인명 변경 <br class="d-none d-md-block" />(주)샤오텍스타일</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2015</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">03.10</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>해외 법인 ㈜샤오텍스 (SHAOTEX Co., LIMITED) 설립</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2014</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-left">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">07.01</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>법인명을 유니텍스 코퍼레이션에서 <br class="d-none d-md-block" />→ (주)메이텍스타일(Meitextile Co., Ltd.)로 변경</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2010</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-right">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">00.00</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>유니텍스 코퍼레이션(Unitex Corp.) 설립</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="history-item">
                    <v-col cols="12" md="6">
                        <h4 class="history-item__year">2000</h4>
                    </v-col>
                    <v-col cols="12" md="6" data-aos="fade-left">
                        <v-row class="row--small">
                            <v-col cols="12" md="auto">
                                <div class="w-50px"><strong class="font-size-14 font-size-md-16">00.00</strong></div>
                            </v-col>
                            <v-col cols="12" md="">
                                <v-row class="row--small page-text">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>유니워스 코퍼레이션(Uniworth Corp.) 설립</v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
    },
};
</script>

<style lang="scss" scoped>
.history-item {
    margin: -8px;
}
.history-item + .history-item {
    margin-top: 24px;
}
.history-item > [class*="col"] {
    padding: 8px;
}
.history-item__year {
    font-size: 4rem;
    line-height: 1;
    color: var(--v-primary-base);
}
.row--small.page-text + .row--small.page-text {
    margin-top: 0;
}
.history-item > [class*="col"] > .row--small + .row--small {
    margin-top: 12px;
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .history-item {
        position: relative;
        margin: -40px;
    }
    .history-item::before {
        content: "";
        position: absolute;
        top: 56px;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        display: block;
        width: 1px;
        height: 100%;
        background-color: var(--border-color);
    }
    .history-item + .history-item {
        margin-top: 0;
    }
    .history-item:last-child:before {
        display: none;
    }
    .history-item > [class*="col"] {
        padding: 40px;
    }
    .history-item__year {
        position: relative;
        font-size: 6rem;
        margin-top: -2rem;
        text-align: right;
        color: var(--v-primary-lighten5);
    }
    .history-item__year::before {
        content: "";
        position: absolute;
        top: 50%;
        right: -55px;
        -webkit-transform: translate(0, -50%);
        -ms-transform: translate(0, -50%);
        transform: translate(0, -50%);
        display: block;
        width: 30px;
        height: 30px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        background-image: url(/images/sub/company/history-symbol.png);
    }
    .history-item:nth-child(even) > [class*="col"]:nth-child(1),
    .history-item:nth-child(even) > [class*="col"]:nth-child(2) > .row > [class*="col"]:nth-child(1),
    .history-item:nth-child(even) .row.page-text > [class*="col"]:nth-child(1) {
        order: 2;
    }
    .history-item:nth-child(even) .history-item__year {
        text-align: left;
    }
    .history-item:nth-child(even) .history-item__year::before {
        right: auto;
        left: -55px;
    }
    .history-item:nth-child(even) > [class*="col"]:nth-child(2) {
        text-align: right;
    }
}
@media (min-width: 1024px) {
    .history-item {
        margin: -70px;
    }
    .history-item + .history-item {
        margin-top: 70px;
    }
    .history-item::before {
        top: 76px;
    }
    .history-item > [class*="col"] {
        padding: 70px;
    }
    .history-item > [class*="col"] > .row--small + .row--small {
        margin-top: 20px;
    }
    .history-item__year {
        font-size: 12rem;
        margin-top: -5rem;
        margin-bottom: 0;
    }
    .history-item__year::before {
        right: -85px;
    }
    .row--small.page-text + .row--small.page-text {
        margin-top: 6px;
    }
    .history-item:nth-child(even) .history-item__year::before {
        right: auto;
        left: -85px;
    }
}
@media (min-width: 1200px) {
}
</style>
